import { isSafePhoneValue } from './is-safe-phone-value.js';
// Phone fields (customer.phone, contact.phone) have no format validation on pre-existing or
// imported rows -- write-time validation only protects records saved after that guard existed.
// This value is rendered as a live tel: href, so an unsafe stored value (e.g. an RFC 3966
// phone-context parameter) must be rejected here too, not just at write time.
export function phoneHref(phone) {
    const trimmed = phone?.trim();
    if (!trimmed)
        return null;
    return isSafePhoneValue(trimmed) ? `tel:${trimmed}` : null;
}
//# sourceMappingURL=phone-href.js.map